import { connectorByIdQuery } from 'src/services/DOM/queries/connectorById/__generated__/connectorByIdQuery.graphql';
import { OverviewType } from '../../../../OverviewCard';
import { printLocalDatetimeWithTimezone } from 'src/products/connector/utils/printLocalDatetimeWithTimezone';
import { getTranslatedCronFrequency } from 'src/products/connector/pages/connector-inventory/utils/translatedCronFrequency';
import { BuildSourcesOverviewReturn } from './model';

const sortSources = (a: string, b: string) => {
  const [aMajor = 0, aMinor = 0, aPatch = 0] = a.split('.').map(Number);
  const [bMajor = 0, bMinor = 0, bPatch = 0] = b.split('.').map(Number);
  if (aMajor !== bMajor) {
    return aMajor - bMajor;
  }
  if (aMinor !== bMinor) {
    return aMinor - bMinor;
  }
  return aPatch - bPatch;
};

export const buildSourcesOverview = (
  sources: connectorByIdQuery['response']['connector']['sources']
): BuildSourcesOverviewReturn[] =>
  sources.map((source) => ({
    type: OverviewType.SOURCE,
    name: source.name,
    displayName: source.displayName,
    provider: source.provider,
    revision:
      source.ingestRevisions
        .map((r) => r.semanticVersion)
        .sort(sortSources)
        .pop() || 'Latest',
    created: printLocalDatetimeWithTimezone(
      'MMM D YYYY h:mm A',
      source.createdAt
    ),
    creator: 'Cherre',
    frequency: getTranslatedCronFrequency(source.schedule),
    statusObject: source.statusObject,
  }));
